import { render, staticRenderFns } from "./ownerDetailContract.vue?vue&type=template&id=70f92bc1"
import script from "./ownerDetailContract.vue?vue&type=script&lang=js"
export * from "./ownerDetailContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports